import { useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import AddBlankPagesToPDFImagesListScreen from "./AddBlankPagesToPDFImagesListScreen";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function AddBlankPagesToPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Add Blank Pages To PDF Document",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: {
      link: "/add_pages_pdf",
      title: "Add Pages To PDF Document Online Free",
    },
    data2: { link: "/add_pages_pdf", title: "Add New Pages To PDF File Free" },
    data3: {
      link: "/add_pages_pdf",
      title: "Add Empty Pages To PDF File Online",
    },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Add blank pages to PDF online or offline easily. Insert pages into PDF files quickly, edit PDFs, and organize documents without hassle."
      ></meta>
      <meta
        name="keywords"
        content="add blank pages to pdf, insert pages into pdf, add pages to pdf online, add pages to pdf offline, edit pdf, organize pdf, pdf page inserter, pdf editor online, pdf tools, pdf management, modify pdf pages, insert blank pages in pdf, add new pages to pdf"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <AddBlankPagesToPDFImagesListScreen
          title={title}
        ></AddBlankPagesToPDFImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Add Blank Pages to PDF File website provides a simple, secure, and efficient solution to insert blank pages into PDF documents directly on your device, without requiring an internet connection. Designed for users who value privacy and flexibility, this powerful tool allows you to add pages to PDF file, insert blank pages at any position, and organize documents exactly as needed. With offline processing, all operations are performed locally, ensuring complete data security and confidentiality without uploading files to external servers. The website also supports optional online usage, enabling users to add blank pages to PDF file for free online when internet access is available. Whether you need to insert blank pages for notes, signatures, separation of sections, or formatting requirements, this tool delivers accurate results while preserving the original document layout and quality. The platform supports add pages to PDF document for free, making it ideal for students, professionals, and businesses looking for a cost-effective PDF editing solution. Using advanced PDF page handling technology, the tool ensures text clarity, images, and formatting remain unchanged after page insertion. Compatible with desktop and mobile devices, this offline PDF page editor helps users customize documents, improve organization, and prepare PDFs for printing, sharing, or official submission. If you are searching for a reliable way to add pages to PDF file, add blank pages to PDF file for free online, or add pages to PDF document for free with complete privacy, this website offers a user-friendly and dependable PDF management experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Add Pages",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Add Blank Pages To PDF Tool"
            why_use={[
              {
                title: "Insert Space for Notes and Annotations",
                description:
                  "Sometimes PDFs need extra space for notes or comments. Using a tool to add blank pages to PDF file makes it easy to include additional writing space.",
              },
              {
                title: "Prepare PDFs for Signatures and Stamps",
                description:
                  "Official documents often require empty pages for signatures or stamps. A feature to add pages to PDF file helps prepare documents for legal and business use.",
              },
              {
                title: "Organize Large PDF Documents",
                description:
                  "Blank pages can separate sections or chapters. Tools that add pages to PDF document for free improve document structure and readability.",
              },
              {
                title: "Meet Printing and Formatting Requirements",
                description:
                  "Some printing standards require blank pages between sections. Using add blank pages to PDF file for free online ensures proper formatting.",
              },
              {
                title: "Improve Document Presentation",
                description:
                  "Adding blank pages enhances the visual flow of a PDF. A simple add pages to PDF file tool creates clean and professional-looking documents.",
              },
              {
                title: "Avoid Recreating PDF Files",
                description:
                  "Instead of rebuilding a document, you can quickly add blank pages to PDF file and update it without extra effort.",
              },
              {
                title: "Useful for Students and Professionals",
                description:
                  "Students and professionals often need extra pages for notes, explanations, or approvals. A tool to add pages to PDF document for free simplifies this task.",
              },
              {
                title: "Maintain Original Content Quality",
                description:
                  "Modern tools preserve text, images, and formatting. When you add blank pages to PDF file, the original content remains unchanged.",
              },
              {
                title: "Work Offline for Better Privacy",
                description:
                  "An offline tool allows you to add pages to PDF file securely without uploading documents to the internet.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How do I add blank pages to a PDF offline?",
                description:
                  "Open the Add Blank Pages to PDF tool in your browser, select your PDF file, choose where to insert blank pages, and process the document. When the tool supports fully local processing, you can complete the task without uploading your PDF to a server."
              },
              {
                title: "Can I add blank pages to a PDF without uploading it?",
                description:
                  "Yes. Shivapdf processes PDF files locally in your browser, allowing you to add blank pages without uploading your document to a server. Your files remain on your device during local processing."
              },
              {
                title: "Is this offline PDF page insertion tool free?",
                description:
                  "You can use the Add Blank Pages to PDF tool on Shivapdf for free, subject to any usage or file size limits displayed on the website."
              },
              {
                title: "Are my PDF files safe when adding blank pages locally?",
                description:
                  "Local PDF processing helps protect your privacy because the document contents remain on your device instead of being sent to a remote server. Always ensure that your browser and the tool are operating as expected."
              },
              {
                title: "Do I need an internet connection to add blank pages to a PDF?",
                description:
                  "An internet connection may be required to open the Shivapdf website initially. If the tool's required resources are available locally, PDF editing can be performed without an active internet connection."
              },
              {
                title: "How can I insert a blank page between existing PDF pages?",
                description:
                  "Select your PDF file and choose the position where you want to insert a blank page. The tool adds an empty page at that position while preserving the order of the remaining pages."
              },
              {
                title: "Can I add multiple blank pages to a PDF?",
                description:
                  "Yes, you can insert multiple blank pages into your PDF using the available page insertion options. Choose the number of pages you need and their positions before saving the updated document."
              },
              {
                title: "Can I add a blank page at the beginning or end of a PDF?",
                description:
                  "Yes, you can insert blank pages at the beginning or end of a PDF to create a title page, leave space for notes, or prepare the document for printing."
              },
              {
                title: "Will my PDF be uploaded to Shivapdf servers?",
                description:
                  "The tool is designed to process PDF files locally in your browser, so the document contents do not need to be uploaded to Shivapdf servers. Local processing helps keep your documents private."
              },
              {
                title: "Does local PDF processing protect my privacy?",
                description:
                  "Processing PDF files locally reduces exposure of document contents because they are handled on your device rather than uploaded to a remote server. Other website activity may still involve network requests, depending on the services used."
              },
              {
                title: "Can I add blank pages to a PDF without installing software?",
                description:
                  "Yes, you can use the browser-based tool without installing a separate PDF editor. Open Shivapdf, select your document, and use the available page insertion options."
              },
              {
                title: "Can I add blank pages to a PDF on my phone?",
                description:
                  "Yes, you can use the tool in a supported mobile browser on an iPhone, Android phone, or tablet. The available file size and processing performance depend on your device and browser."
              },
              {
                title: "Will adding blank pages change my original PDF?",
                description:
                  "The tool creates an updated PDF with the requested blank pages. Your original file should remain unchanged unless you choose to overwrite it yourself."
              },
              {
                title: "Will adding blank pages reduce PDF quality?",
                description:
                  "Inserting blank pages does not inherently reduce the quality of existing PDF content. The original text, images, and page appearance should remain intact when the document is processed correctly."
              },
              {
                title: "Can I add blank pages to a scanned PDF locally?",
                description:
                  "Yes, supported scanned PDFs can be edited locally in your browser. Adding blank pages does not require re-scanning or changing the existing scanned page images."
              },
              {
                title: "Can I use this tool for confidential PDF documents?",
                description:
                  "Local processing is useful for confidential documents because their contents can remain on your device. For sensitive files, verify that processing occurs locally and review the website's privacy policy."
              },
              {
                title: "What happens if my PDF file is too large?",
                description:
                  "Large PDFs may require more memory and processing time. If a file cannot be processed, try a smaller PDF or use a device with sufficient available memory."
              },
              {
                title: "How do I save my PDF after inserting blank pages?",
                description:
                  "Once processing is complete, select the download option to save the updated PDF to your device. Open the saved document to verify the inserted pages and page order."
              }
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1624184310}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default AddBlankPagesToPDFMain;
